import React from 'react';
import Types from 'prop-types';
var FooterIconLink = function FooterIconLink(_ref) {
  var link = _ref.link,
    external = _ref.external,
    Icon = _ref.Icon,
    ariaLabel = _ref.ariaLabel;
  return /*#__PURE__*/React.createElement("a", {
    href: link,
    className: "link-icon",
    target: external ? '_blank' : undefined,
    rel: "noopener noreferrer",
    "aria-label": ariaLabel
  }, /*#__PURE__*/React.createElement(Icon, {
    size: 24
  }));
};
FooterIconLink.defaultProps = {
  external: false
};
export default FooterIconLink;